import type { DynamicPropertyEntity } from "src/app/features/DynamicProperty/types/DynamicPropertyEntity";
import type { DynamicPropertyDto } from "../../types/DynamicPropertyDto";

export const DynamicPropertyDtoToEntity = ({ key, ...rest }: Readonly<DynamicPropertyDto>): DynamicPropertyEntity => {
    return { ...rest, keyProp: key };
};
